// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".migrationBanner {\n  width: 100%;\n  padding: 0 1rem;\n}\n.modal-header {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n.bannerBody {\n  font-weight: normal;\n}\n.learnMore {\n  font-weight: bold !important;\n  color: var(--carbon-900) !important;\n}", ""]);
// Exports
module.exports = exports;
